import { Route, Routes } from "react-router-dom";

import { PorttelefonPage } from "./PorttelefonPage";

export const IndexPage = () => {
  return (
    <>
      <Routes>
        <Route
          path="*"
          element={<PorttelefonPage />}
        />
      </Routes>
    </>
  );
};
